import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SharedService {
  private companyIdSource = new BehaviorSubject<number>(-1);
  currentCompanyId$ = this.companyIdSource.asObservable();

  constructor() {}

  setCurrentCompanyId(companyId: number) {
    this.companyIdSource.next(companyId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts.ts